module.exports = __webpack_public_path__ + "bee44291690bf9f858a9d4e24866e30c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Hattori_S.jpg
// module id = 56
// module chunks = 0